import { Reducer } from 'react';
import { InspectionViewState } from 'store/analytics/ui/analyticsUiTypes';
import {
  InspectionViewActionTypes,
  SELECT_INSPECTION_VIEW_REQUEST,
  SELECT_REQUEST_DETAIL_TAB,
  SET_INSPECTION_VIEW_ACTIVE_PAGE,
  SET_INSPECTION_VIEW_PAGE_SIZE,
  SET_SEARCH_KEYWORD,
} from 'store/analytics/ui/subViews/inspectionView/inspectionViewActionTypes';

export const inspectionViewInitialState: InspectionViewState = {
  activePage: 1,
  pageSize: 5,
  searchKeyword: '',
  selectedRequest: null,
  selectedViewTab: 'defaultTab',
};

export const inspectionViewReducer: Reducer<InspectionViewState, InspectionViewActionTypes> = (
  state = inspectionViewInitialState,
  action,
): InspectionViewState => {
  switch (action.type) {
    case SET_INSPECTION_VIEW_ACTIVE_PAGE:
      return { ...state, activePage: action.payload };
    case SET_INSPECTION_VIEW_PAGE_SIZE:
      return { ...state, pageSize: action.payload };
    case SELECT_INSPECTION_VIEW_REQUEST:
      return { ...state, selectedRequest: action.payload };
    case SELECT_REQUEST_DETAIL_TAB:
      return { ...state, selectedViewTab: action.payload };
    case SET_SEARCH_KEYWORD:
      return { ...state, searchKeyword: action.payload };
    default:
      return state;
  }
};
